module.exports = __webpack_public_path__ + "img/labor-for-good.8bc07533.png";